// extracted by mini-css-extract-plugin
export default {"thead":"mantineTable_thead__O786i","tr":"mantineTable_tr__q4Sm+","th":"mantineTable_th__gdI2v","td":"mantineTable_td__5w0Vp"};